// © Microsoft Corporation. All rights reserved.

import PublisherProfileCard from "../publisher-profile-card/PublisherProfileCard";
import PublisherProfileTabs from "../publisher-profile-tabs/PublisherProfileTabs";
import React from "react";
import { SocialProps } from "../../Social.props";
import { classNames } from "@microsoft/fast-web-utilities";
import { initializeSubscriptionSdk } from "@msnews/subscription-sdk-wrapper";

export default class PublisherProfilePage extends React.Component<SocialProps> {

    constructor(props) {
        super(props);
        initializeSubscriptionSdk();
    }

    componentDidMount() {
        this.props.profileConnector && this.props.profileConnector.onProfilePageComponentConnected(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id != null && this.props.market != null && prevProps.id != this.props.id || prevProps.market != this.props.market) {
            this.props.profileConnector && this.props.profileConnector.onProfilePageComponentConnected(this.props.id);
        }
    }

    render() {
        return (
            <div className={classNames(this.props.managedClasses.publisherProfilePageContainer, this.props.responsiveClass)}>
                <PublisherProfileCard {...this.props} />
                <PublisherProfileTabs {...this.props} />
            </div>
        );
    }
}